import { useMutation, useQueryClient } from "@tanstack/react-query";
import { runTargetareMatrice } from "@/api/endpoints/targetareMatrice";
import { queryKeys } from "@/lib/queryClient";

export function useRunTargetareMatrice() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: runTargetareMatrice,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.targetare.stats() });
    },
  });
}
